import intl from 'react-intl-universal';
import dayjs from 'dayjs';
import math from './math';
import { formatJSON } from '../utils';
import GiftIcon from '../components/Icon/GiftIcon';

/**
 * 获取优惠券有效期文本
 * 未领券时显示
 * @param {object} item 优惠券对象
 * @returns {string} 优惠券有效期文本
 */
export const getCouponValidDate = (item) => {
    const countType = {
        3: intl.get('day').d('天'),
        4: intl.get('hour').d('小时'),
        5: intl.get('minute').d('分钟')
    };
    const expiredStr = countType[item.validityBeginCountType] || intl.get('day').d('天');
    let validTxt = '';

    if (item.validityBeginType === 1) {
        validTxt = `${dayjs(item.validityStartTime).format('YYYY-MM-DD')} ~ ${dayjs(item.validityEndTime).format('YYYY-MM-DD')}`;
    } else if (item.validityBeginType === 2) {
        validTxt = intl.get('unlimited').d('无限');
    } else if (item.validityBeginType === 3) {
        const str = intl.get('equity_received_day_valid', {
            num: item.validityBegin,
            count: item.validityBeginCount,
            unit: expiredStr
        }).d(`领取后${item.validityBegin}天生效,有效期为 ${item.validityBeginCount} ${expiredStr}`);

        validTxt = getValidText(item, str, expiredStr);
    } else if (item.validityBeginType === 4) {
        const str = intl.get('equity_received_time_valid',
            {
                num: item.validityBegin,
                count: item.validityBeginCount,
                unit: expiredStr
            }).d(`领取后${item.validityBegin}小时生效,有效期为 ${item.validityBeginCount} ${expiredStr}`);

        validTxt = getValidText(item, str, expiredStr);
    }
    return validTxt;
}

const getValidText = (item, str, expiredStr) => {
    if (item.validityBegin === 0) {
        return `${intl.get('effective_now').d('即时生效')}, ${intl.get('valid_time').d('有效时间')} ${item.validityBeginCount} ${expiredStr}`;
    } else {
        return str
    }

}

/**
 * 获取优惠券有效期文本
 * 已领券时显示
 * @param {object} item 优惠券对象
 * @returns {string} 优惠券有效期文本
 */
export const getExpiredText = (item) => {
    const { validityStartTime, validityEndTime } = item;
    if (validityStartTime && validityEndTime) {
        return `${dayjs(validityStartTime).format('YYYY-MM-DD')} ~ ${dayjs(validityEndTime).format('YYYY-MM-DD')}`;
    } else {
        return intl.get('unlimited').d('无限');
    }
}

/**
 * 获取优惠券类型文本
 * @param {number} couponType 优惠券类型
 * @returns {string} 优惠券类型文本
 */
export const getCouponTypeText = (couponType) => {
    const types = {
        1: intl.get('od_full_reduce_coupon').d('满减券'),
        2: intl.get('od_discount_coupon').d('折扣券'),
        3: intl.get('equity_gift_coupon').d('礼品券')
    };
    return types[couponType] || '';
}

/**
 * 获取优惠券折扣文本
 * @param {object} item 优惠券对象
 * @returns {string} 优惠券折扣文本
 */
export const getDiscountDisplay = (item) => {
    if (item.couponType === 2) {
        const discountNum = intl.get('ver.type') === 1 ? item.couponDiscount * 10 : math.sub(100, item.couponDiscount * 100);
        return intl.get('od_discount_str', { num: discountNum }).d(`${discountNum}折`);
    } else if (item.couponType === 3) {
        return <><GiftIcon width={14} height={14} color='#FF0000' /></>;
    }
    return item.couponReachDiscount;
}

/**
 * 获取优惠券使用规则文本
 * @param {object} item 优惠券对象
 * @returns {string} 优惠券使用规则文本
 */
export const getUseRule = (item) => {
    if (item.useRule) {
        const ruleObj = formatJSON(item.useRule);
        return ruleObj.briefDesc;
    }
    return '';
}

/**
 * 获取优惠券使用门槛文本
 * @param {object} item 优惠券对象
 * @returns {string} 优惠券使用门槛文本
 */
export const getReachCanUseText = (item) => {
    if (item.couponReach) {
        return intl.get('od_reach_n_can_use', { amount: item.couponReach }).d(`满 ${item.couponReach} 可用`);
    }
    // return intl.get('od_unlimited').d('无门槛');
    return '';
}